<iot-platform-ui-loader [display]="notificationService.loader$ | async"></iot-platform-ui-loader>
